import Arrow from '../../icons/arrow';

/** 
 * @param {string} heading
 * @param {string} subHeading
 * @param {string} imageSrc
 * @param {function} clickHandler
*/
function SmallOptionBoxWithImage(props){
    if(props.clickHandler === undefined){
        return null;
    }
    return (
        <li className="book-meeting__advisor-card">
           <button className="book-meeting__advisor-wrapper"
                aria-label={props.heading}
                onClick={() => {
                    props.clickHandler();
                }}
                tabIndex="0"
            >
                <img className="book-meeting__advisor-img" src={props.imageSrc} alt={"Bilde av " + props.heading} />
            
                <div className="book-meeting__content">
                    <p className="book-meeting__advisor-name">{props.heading}</p>                
                    <p className="book-meeting__advisor-title">{props.subHeading}</p>                              
                </div>
            
            </button>
        </li>
    );
}
export default SmallOptionBoxWithImage;